import { Icon } from "icons";
import { useTranslation } from "react-i18next";

interface SavedSectionToastTitleProps {
  sectionName: string;
}

export function SavedSectionToastTitle(props: SavedSectionToastTitleProps) {
  const translation = useTranslation();

  return (
    <div className="flex items-start gap-2">
      <Icon
        name="tabler-check"
        className="mt-0.5 size-4 shrink-0 text-[#09AC64]"
        strokeWidth={3}
      />
      <span className="text-sm font-semibold leading-5 text-zinc-950">
        {translation.t("editWorkout.workoutItemActions.saveAsSectionSuccess", {
          name: props.sectionName,
        })}
      </span>
    </div>
  );
}
